module.exports = __webpack_public_path__ + "img/PY.a2f0fec2.svg";